/* eslint-disable */
import { Auditor, LegalShareholder, Person, PhysicalPerson } from './Person';
import { User } from './User';

export interface BuyProcessApiRequest {
  // 1. Customer, contact person, client who is ordering
  client: Person;

  // 2. Company information
  company: Company;

  // 3. Owner / Shares
  shareCapital: number;
  numberShares: number;
  physicalPeople: PhysicalPerson[]; // Adding each person number of shares should be equal to the sum of shared capital
  legalShareholders: LegalShareholder[]; // Here as well
  beneficialOwnerHelp: boolean; // + 445kr

  // 4. Reservation
  rightFirstRefusal: boolean; // Hembud
  stockRestrictions: StockRestrictions;

  // 5. Representatives of the company; only physical people and new ones
  representatives: Person[];
  officialCeo: boolean;
  ceo?: Person | PhysicalPerson;
  signAuthority: SignAuthority | string; // Predifened 5 constants, or other custom written by user

  // 6. Fiscal year
  fiscalYear: FiscalYear;
  /*
  Possibility to extend the fiscal year. Do a calculation:
  If, for example FiscalYear.JanuaryStart is chosen,
  check if `NOW + 18 months` would satisfy ${nextYear}-2021-12-31.
  If true, this date is taken as "firstClosingDate" and it represents the extended fiscal year
  */
  extendedFiscalYear: boolean;
  firstClosingDate?: Date;

  // 7. Auditors
  auditor?: Auditor;

  // 8. Power of attorney
  powerOfAttorney: {
    firstName: string;
    lastName: string;
    socialSecurityNumber: string;
    relationType?: RelationType;
  };

  // Recipient
  recipient: InvoiceRecipient;
}

export interface Company {
  desiredCompanyName: string;
  firstAlternativeCompanyName: string;
  secondAlternativeCompanyName: string;
  nameReview: boolean; // + 475kr extra service for double check
  address: string;
  postalCode: string;
  city: string;
  municipality: string;
  businessDescription: string;
  taxHelp: boolean; // + 695kr extra service for application, taxes help
}

enum StockRestrictions {
  None, // Nej, tack
  Consent, // Samtycke
  RightFirstOffer, // Förköp
}

enum SignAuthority {
  AB1 = 'ab1',
  AB2 = 'ab2',
  AB3 = 'ab3',
  AB4 = 'ab4',
  AB5 = 'ab5',
  ABX = 'Custom',
}

enum FiscalYear {
  JanuaryStart = '0112',
  FebruaryStart = '0201',
  MarchStart = '0302',
  AprilStart = '0403',
  MayStart = '0504',
  JuneStart = '0605',
  JulyStart = '0706',
  AugustStart = '0807',
  SeptemberStart = '0908',
  OctoberStart = '1009',
  NovemberStart = '1110',
  DecemberStart = '1211',
}

enum RelationType {
  None = -1,
  ContactPerson = 1,
  PhysicalShareHolder = 2,
  LegalShareHolder = 4,
  Shareholders = PhysicalShareHolder | LegalShareHolder,
  ViceCeo = 7,
  Ceo = 8,
  ExtrernalSubstituteCeo = 9,
  ExternalCeo = 10,
  SubstituteAuditor = 11,
  ExternalSignatory = 12,
  SpecialServiceRecepient = 13,
  NotifiablePerson = 14,
  PowerOfAttorney = 16,
  SubstituteBoardMember = 32,
  BoardMember = 64,
  Chairman = 128,
  Representatives = Chairman | BoardMember | SubstituteBoardMember,
}

enum InvoiceRecipient {
  Customer = '1',
  Company = '2',
}

export interface BuyOrder extends BuyProcessApiRequest {
  // Entered by staff, shelf company

  organizationName: string;
  organizationNumber: string;
  invoiceNumber: string;
  internalDealDate: Date;
  registrationDate: Date;
  internalManager: User;
}

export {
  FiscalYear,
  SignAuthority,
  StockRestrictions,
  RelationType,
  InvoiceRecipient,
};
